import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import {
  IExpenseType,
  ICreateExpenseTypeRequest,
  IUpdateExpenseTypeRequest,
  ISearchExpenseTypesRequest
} from '../models/expense-type';

@Injectable({
  providedIn: 'root'
})
export class ExpenseTypeService {

  constructor(private http: HttpClient) { }

  searchExpenseTypes(request: ISearchExpenseTypesRequest = { pageNumber: 0, pageSize: 999999 }) {
    return this.http.post<IPagedResults<IExpenseType[]>>(
      `${environment.baseUrl}/v1/ExpenseType/SearchExpenseTypes`,
      request
    );
  }

  getExpenseType(id: string) {
    return this.http.get<IExpenseType>(
      `${environment.baseUrl}/v1/ExpenseType/GetExpenseType/${id}`
    );
  }

  createExpenseType(request: ICreateExpenseTypeRequest) {
    return this.http.post<string>(
      `${environment.baseUrl}/v1/ExpenseType/CreateExpenseType`,
      request
    );
  }

  updateExpenseType(request: IUpdateExpenseTypeRequest) {
    return this.http.put<string>(
      `${environment.baseUrl}/v1/ExpenseType/UpdateExpenseType/${request.id}`,
      request
    );
  }

  deleteExpenseType(id: string) {
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/ExpenseType/DeleteExpenseType/${id}`
    );
  }
}
